import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ALL } from 'constants/socket'
import useLocalAudioToggle from 'hooks/useLocalAudioToggle/useLocalAudioToggle'
import { dispatchReceiveAudioMessage } from 'store/dispatcher'
import { _audioMsg } from 'store/selectors/WebSocket'
import { logger } from 'utils/logger'

export function useAudioToggle(isLocal, uuid) {
    const audioMsg = useSelector(_audioMsg)
    const [isEnabled, toggleAudioEnabled] = useLocalAudioToggle()

    useEffect(() => {
        if (!audioMsg || !isLocal || !uuid) return

        const shouldMute = [ALL, uuid].includes(audioMsg.user_id) && isEnabled

        if (shouldMute) {
            toggleAudioEnabled()
            dispatchReceiveAudioMessage(null) // empty audioMsg from store
            logger.info(`Teacher muted`)
        }
    }, [audioMsg, isLocal, uuid, isEnabled, toggleAudioEnabled])
}
